module.exports = __webpack_public_path__ + "static/media/uiux-design-starter-with-adobe-xd.c7973cd5.md";